var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.976 15.154a.6.6 0 1 0 .848.849l3.165-3.165 3.187 3.186a.6.6 0 0 0 .848-.848l-3.186-3.187 3.164-3.165a.6.6 0 0 0-.848-.848l-3.165 3.164-3.143-3.142a.6.6 0 0 0-.848.848l3.142 3.143z"
  })));
};
export default SvgCloseIcon;